import { render, staticRenderFns } from "./channel-info.vue?vue&type=template&id=3d748ddf&scoped=true&"
import script from "./channel-info.vue?vue&type=script&lang=js&"
export * from "./channel-info.vue?vue&type=script&lang=js&"
import style0 from "./channel-info.vue?vue&type=style&index=0&id=3d748ddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d748ddf",
  null
  
)

export default component.exports